import { MprcMessageBox } from "components";
import { ButtonClose } from "components/buttons";
import React from "react";
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////

export const AccountLockout: React.FC<{ onClose: () => void; }> = ({ onClose }) => {
    const { t } = useTranslation();

    return (
        <MprcMessageBox
            size="medium"
            variant="error"
            message={
                <>
                    <b>{t("Auth.AccountLockout.MessageL1")}</b>
                    <p>{t("Auth.AccountLockout.MessageL2")}</p>
                </>
            }
            action={<ButtonClose variant="contained" color="error" onClick={onClose} />}
        />
    );
};
